<template>
    <span>
      {{ _date }}
    </span>
</template>

<script>
import moment from 'moment';
moment.locale('pt-br');
export default {
    props:{
        date:{
            default:""
        },
        format:{
            type:String,
            default:'ll'
        }
    },
    computed:{
        _date:function(){
            return moment(this.date).format(this.format)
        }
    }
}
</script>

<style>

</style>
